import { ResearchFormIcaro } from 'civil-status/view-models/research-form-icaro';
import { SelectOperatorChoice } from 'shell/constants/select-choice-operator';

export const defaultInitialValuesResearchFormIcaro: ResearchFormIcaro = {
  year: '',
  number: '',
  dateDeclarationEnd: null,
  dateDeclarationStart: null,
  state: '',
  numberAct: '',
  dateOperationStart: null,
  dateOperationEnd: null,
  name: '',
  surname: '',
  nameOperation: SelectOperatorChoice.Equal,
  surnameOperation: SelectOperatorChoice.Equal,
  dateBorn: null,
  typePerson: '',
  hospital: '',
};
